import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { Title } from '../../components/common/Title'
import { GeneTypesTable } from '../../features/gene-types'

export const Table = (props: RouteProps) => {
  return (
    <>
      <Title color={props.color} title={props.title || ''} />
      <GeneTypesTable />
    </>
  )
}
